import { Api } from "./api"

export class InvitationReminderApi extends Api {
  constructor() {
    super('invitation_reminders', ['cupperId'])
  }
}
